import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
 
 
//解决  NavigationDuplicated: Avoided redundant navigation to current location: 报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
 

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [ 
    {
      path: '/',
      name: 'Home',
      component: Home
    },
	{
	  path: '/about',
	  name: 'About',
	  component: About
	},
 
	
	//------------以上是基础框架-----------------
	 
  ]
})
